module.exports = __webpack_public_path__ + "fonts/FuturaPT-BookObl.3c80792f.woff2";